import React, {PureComponent} from "react"
import QRCode from "react-qr-code";
import FancyArrow from "./fancy-arrow.svg";
import {selectImage} from "./imageSizing";

//
// url is a location object or a URL
//
// converts case-insenstive parts to uppercase,  removes hash and query parts
// to make something suitable for a high density QR code assuming you use
// only QR-alphanumeric characters in your URL
//

const cleanQRL = (url) => {
    var that = url.protocol.toUpperCase()
    that = that + "//"
    that = that + url.hostname.toUpperCase()
    if (url.port) {
        that = that + ":" + url.port
    }
    that = that + url.pathname
    return that
}

const OptionalA = (props) => {
    const {children, ...others} = props
    if(props.href) {
        return <a {...others}>{children}</a>;
    }

    return <span {...others}>{children}</span>
}

const PreparedBy = (props) => {
    let { prepared_by } = props
    if (typeof prepared_by === "string") {
        prepared_by = {name: prepared_by}
    }
    const { name, version } = prepared_by
    return <>{name} {version}</>
}

//
// unfortunately the <QRCode> component doesn't support the alphanumeric QR
// code encoding; this breaks the design rules for 3-sided cards but that's
// the least of what's wrong with this system
//

class QRVirus extends PureComponent {
    render = () => {
        const { config, pathname } = this.props
        const { images, date_prepared, prepared_by, prepared_link } = config
        const barcode_url = cleanQRL(window.location)
        const selectedImage = selectImage(images, 256, 256)
        const imgUrl = pathname + selectedImage.name

        return <article className={"QRVirus"}>
            <h1>Scan QR Code to view this photo on a mobile device</h1>
            <div className={"flexRow"}>
                <div className="barcode"><QRCode value={barcode_url}/></div>
                <div className="arrow"><img src={FancyArrow} width={100} alt={"will load"}/></div>
                <div className="thumbnail"><img height={256} src={imgUrl} alt={"this photograph"} /></div>
            </div>
            <div className={"attribution"}>
                <div><b>Apollo/Gorgon</b> photo shell v1.0; images and data prepared by {" "}
                    <b><OptionalA href={prepared_link}><PreparedBy prepared_by={prepared_by}/></OptionalA></b>
                {" "} at {date_prepared}.</div>
                <div>&copy; 2021 by <b>Ontology<sup className={"two"}>2</sup></b> All Rights Reserved</div>
            </div>
        </article>
    }

    static page_title = "QR Code"
}

export default QRVirus;

